/*
Controller: Jwt

Operations:
  signPayloadWithJwt
*/
var Api = require('../config')
var JwtSigningPayloadDef = require('../definitions/JwtSigningPayload')

var Jwt = (function () {
  /*
  Operation: signPayloadWithJwt
  Generate JWT Token
  Parameters:
    bodyRequest: Payload for which JWT token needs to be generated.
  Responses:
    HTTP 200: Successful operation
    HTTP 400: Invalid payload
    HTTP 500: Server error
  */
  function signPayloadWithJwtJwt (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        JwtSigningPayloadDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/sign-payload'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['signPayloadWithJwt'] = signPayloadWithJwtJwt
  return ret
})()

module.exports = Jwt
